<a 
    class="base {{color}} {{variant}} {{size}}"
    href="{{link}}"
    target="_blank"
  >
    <ng-content></ng-content>
  </a>